import {ChangeDetectionStrategy, Component, Injector, Renderer2, ViewChild} from '@angular/core';
import {GenericElm} from '../../player/generic.elm';
import {Observable, of, switchMap, takeUntil} from 'rxjs';
import {catchError} from "rxjs/operators";
import {Expiration} from "../../interfaces/Expiration";
import {DateUtils} from "../../utils/DateUtiles";
import {CachingService} from "../../services/caching/caching.service";
import {ItemComponent} from "../../player/item.component";
import {SceneComponent} from "../scene/scene.component";
import {IPlayerContainer} from "../../interfaces/IPlayerContainer";

@Component({
  selector: 'app-json-item',
  template: '<div #component></div>',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class JsonItemComponent extends ItemComponent {
    constructor(protected injector: Injector) {
        super(injector);
        this.folder = 'json';
    }

    load(playerObject: any): Observable<any> {
        let self;
        return super.load(playerObject).pipe(
            switchMap(playerBase => {
                self = playerBase;
                this.fieldType = this.data.XmlItem[0].$.fieldType;
                this.fieldName = this.data.XmlItem[0].$.fieldName;


                this.aspectRatio = this.data.XmlItem[0]?.$.maintainAspectRatio == "1";

                if (this.genericElm == null) {
                    this.genericElm = new GenericElm(this.component);
                }

                if (this.parentPlayer.parentPlayer != null && this.parentPlayer.parentPlayer.data.DataProvider != null) {
                    this.metadata = this.parentPlayer.parentPlayer.data.DataProvider[0].$.metadata;
                }


                if (this.metadata == "500px.user" && this.fieldName == "image_url") {
                    this.fieldName = "image_url[0]";
                }

                this.fieldName = this.fieldName.replace(/\[/g, '.');
                this.fieldName = this.fieldName.replace(/\]/g, '');

                if (this.fieldName[0] == '$') {
                    this.fieldName = this.fieldName.substring(this.fieldName[1] == '[' ? 2 : 1);
                    this.fieldName = this.fieldName.replace(/\[/g, '.');
                    this.fieldName = this.fieldName.replace(/\]/g, '');
                }

                if (this.fieldName[0] == '.') {
                    this.fieldName = this.fieldName.substring(1);
                }


                if (this.fieldType === 'text' || this.fieldType == 'date') {
                    if (this.parentPlayer.parentPlayer != null) {
                        const unit = (<any>this.parentPlayer.parentPlayer).unit; //???
                        if (unit != null) {
                            this.fieldName = this.fieldName.replace(/@/g, unit);
                        }
                    }

                    if (this.fieldType == 'date') {
                        this.dateFormat = this.data.XmlItem[0].$.dateFormat;
                    }

                    const font = this.data.XmlItem[0].Font[0].$;
                    this.genericElm.fontStyle = this.getFontStyle(font);
                    return this.playerService.caching.requestFont(font);
                } else {
                    return of(null);
                }
            }),
            switchMap(r => {
                let childProviderData;
                let playVideoInFull = false;

                if (this.parentPlayer != null) {
                    childProviderData = (<SceneComponent>this.parentPlayer).childProviderData;
                }
                return this.invalidateData(childProviderData, playVideoInFull); //???
            }),
            catchError(err => this.logError(err)),
            switchMap(a => of(self)),
            takeUntil(this.finish$)
        )
    }

    invalidateObject(value): Observable<any> {
        let id;
        let ext;
        const token = (<any>this.parentPlayer.parentPlayer).token;
        let volume = 1.0;
        if (this.parentPlayer?.parentPlayer != null) {
            volume = (<IPlayerContainer>(this.parentPlayer.parentPlayer)).volume;
        }
        if (this.metadata == 'drive') {
            id = value;
            ext = this.providerData['fileExtension'];
            console.log('id=' + id);
            return this.playerService.caching.getDriveUrl(token, id, Expiration.Minute).pipe(
                switchMap(url => {
                    return this.genericElm.setMedia(url, this.aspectRatio, this.actualWidth, this.actualHeight, false, volume, ext);
                }),
                catchError(e => {
                    console.log('error=')
                    return of(null);
                })
            );
        } else { // dropbox
            id = value;
            ext = value.substring(value.lastIndexOf('.') + 1);
            return this.playerService.caching.getDropboxUrl(token, id, Expiration.Minute).pipe(
                switchMap(url => {
                    return this.genericElm.setMedia(url, this.aspectRatio, this.actualWidth, this.actualHeight, false, volume, ext);
                })
            );
        }
    }

}
